import { render, staticRenderFns } from "./StampDutyExemptionForm.vue?vue&type=template&id=b9fcc794&scoped=true&"
import script from "./StampDutyExemptionForm.vue?vue&type=script&lang=js&"
export * from "./StampDutyExemptionForm.vue?vue&type=script&lang=js&"
import style0 from "./StampDutyExemptionForm.vue?vue&type=style&index=0&id=b9fcc794&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9fcc794",
  null
  
)

export default component.exports